import { useTheme } from '@mui/material/styles';

type Colors = 'red' | 'yellow' | 'green';
type Field = 'icon' | 'text';

export const useGetColor = () => {
  const theme = useTheme();

  const map = {
    green: {
      icon: theme.palette.success.light,
      text: theme.palette.success.main,
    },
    yellow: {
      icon: theme.palette.warning.light,
      text: theme.palette.warning.main,
    },
    red: {
      icon: theme.palette.error.light,
      text: theme.palette.error.main,
    },
  };

  const getColor = (field: Field, color?: Colors) => {
    if (!color) {
      return theme.palette.text.disabled;
    }

    return map[color][field];
  };
  return { getColor };
};
